module.exports = __webpack_public_path__ + "imgs/PaceIndy.b0c141ec89648c70d7c18e0bfbc941bf.png";